<form [formGroup]="contactForm">
    <div class="row mb-3">
        <label
            class="col-md-3 col-form-label text-start text-md-end"
            for="internalInfoContactDropDown"
            translate="INTERNAL_INFO_CONTACTS_TITLE"
        >
        </label>
        <pace-core-dropdown
            [(model)]="model.contactModel"
            [parentForm]="contactFormChildren"
            class="col-md-9"
            id="internalInfoContactDropDown"
        >
        </pace-core-dropdown>
    </div>
    <hr />
    @if (model.contactModel.selectedEntry) {
        <fieldset [disabled]="!categoryModel.isEdited">
            <div class="row mb-3">
                <label
                    class="col-md-3 col-form-label text-start text-md-end"
                    for="functionName"
                    translate="INTERNAL_INFO_CONTACTS_FUNCTION_NAME"
                >
                </label>
                <div class="col-md-9">
                    <pace-core-text-input
                        (valueChange)="onValueChange($event)"
                        [(model)]="model.contactModel.selectedEntry.model.functionName.textLine"
                        [parentForm]="contactFormChildren"
                        id="functionName"
                        #functionName
                        name="functionName"
                        [ariaLabel]="'INTERNAL_INFO_CONTACTS_FUNCTION_NAME' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-md-3 col-form-label text-start text-md-end"
                    for="infoName"
                    translate="INTERNAL_INFO_CONTACTS_NAME"
                >
                </label>
                <div class="col-md-9">
                    <pace-core-text-input
                        #infoName
                        (valueChange)="onValueChange($event)"
                        [(model)]="model.contactModel.selectedEntry.model.contactName.textLine"
                        [parentForm]="contactFormChildren"
                        id="infoName"
                        name="infoName"
                        [ariaLabel]="'INTERNAL_INFO_CONTACTS_NAME' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-md-3 col-form-label text-start text-md-end"
                    for="email"
                    translate="INTERNAL_INFO_CONTACTS_EMAIL"
                >
                </label>
                <div class="col-md-9">
                    <pace-core-text-input
                        (valueChange)="onValueChange($event, true)"
                        [(model)]="model.contactModel.selectedEntry.model.email.textLine"
                        [parentForm]="contactFormChildren"
                        id="email"
                        name="email"
                        [ariaLabel]="'INTERNAL_INFO_CONTACTS_EMAIL' | translate"
                    ></pace-core-text-input>
                    @if (isEmailInvalid) {
                        <span class="error-text" translate="RECIPIENT_INVALID_EMAIL_ERROR_MESSAGE"> </span>
                    }
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-md-3 col-form-label text-start text-md-end"
                    for="telephone"
                    translate="INTERNAL_INFO_CONTACTS_TELEPHONE_NUMBER"
                >
                </label>
                <div class="col-md-9">
                    <pace-core-text-input
                        (valueChange)="onValueChange($event)"
                        [(model)]="model.contactModel.selectedEntry.model.telephoneNumber.textLine"
                        [parentForm]="contactFormChildren"
                        id="telephone"
                        name="telephone"
                        [ariaLabel]="'INTERNAL_INFO_CONTACTS_TELEPHONE_NUMBER' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-md-3 col-form-label text-start text-md-end"
                    for="mobile"
                    translate="INTERNAL_INFO_CONTACTS_MOBILE"
                >
                </label>
                <div class="col-md-9">
                    <pace-core-text-input
                        (valueChange)="onValueChange($event)"
                        [(model)]="model.contactModel.selectedEntry.model.mobile.textLine"
                        [parentForm]="contactFormChildren"
                        id="mobile"
                        name="mobile"
                        [ariaLabel]="'INTERNAL_INFO_CONTACTS_MOBILE' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-md-3 col-form-label text-start text-md-end"
                    for="department"
                    translate="INTERNAL_INFO_CONTACTS_DEPARTMENT"
                >
                </label>
                <div class="col-md-9">
                    <pace-core-text-input
                        (valueChange)="onValueChange($event)"
                        [(model)]="model.contactModel.selectedEntry.model.department.textLine"
                        [parentForm]="contactFormChildren"
                        id="department"
                        name="department"
                        [ariaLabel]="'INTERNAL_INFO_CONTACTS_DEPARTMENT' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-md-3 col-form-label text-start text-md-end"
                    for="notes"
                    translate="INTERNAL_INFO_CONTACTS_NOTES"
                >
                </label>
                <div class="col-md-9">
                    <pace-core-text-input
                        #notes
                        (valueChange)="onValueChange($event)"
                        [(model)]="model.contactModel.selectedEntry.model.notes.textLine"
                        [parentForm]="contactFormChildren"
                        id="notes"
                        name="notes"
                        [ariaLabel]="'INTERNAL_INFO_CONTACTS_NOTES' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        </fieldset>
    }
</form>
<div class="modal-footer justify-content-between justify-content-md-end">
    @if (!categoryModel.isEdited || !model.contactModel.selectedEntry) {
        <button
            (click)="onAdd()"
            [disabled]="categoryModel.isEdited"
            class="btn btn-primary"
            translate="INTERNAL_INFO_ADD_BUTTON_LABEL"
        ></button>
    }
    <button
        (click)="deleteInternalInfoContact()"
        [disabled]="!model.contactModel.selectedEntry"
        class="btn btn-primary"
        translate="INTERNAL_INFO_DELETE_BUTTON_LABEL"
    ></button>
    @if (!categoryModel.isEdited) {
        <button
            (click)="onEdit()"
            [disabled]="!model.contactModel.selectedEntry"
            class="btn btn-primary"
            translate="INTERNAL_INFO_EDIT_BUTTON_LABEL"
        ></button>
    }
    @if (categoryModel.isEdited) {
        <button (click)="onCancel()" class="btn btn-primary" translate="INTERNAL_INFO_CANCEL_BUTTON_LABEL"></button>
    }
</div>
